export enum LiveStatusSubject {
  peo = 'peo',
  employer = 'employer',
}
